import { config } from "config.env"
import { login, logout } from "./authSlice"
import axios from "axios"

const domain = config.API_ENDPOINT

export const refreshToken = () => async (dispatch) => {
    try {
        const refresh = localStorage.getItem('RefreshToken')
        const res = await axios.put(`${domain}/api/v1/system/refreshToken`, { refresh_token: refresh })

        console.log('REFRESH RESPONSE:', res.data)

        const newAccessToken = res.data.data.access_token
        const newReToken = res.data.data.refresh_token

        localStorage.setItem('AccessToken', newAccessToken)
        localStorage.setItem('RefreshToken', newReToken)

        dispatch(login(res.data.data))
    } catch (err) {
        console.error('REFRESH ERROR:', err)
        dispatch(logout())
        localStorage.clear()
    }
}
